import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback } from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { bool, object } from 'prop-types';
import useTouchDetection from "../../hooks/useTouchDetection";
import { ChevronNormalDown } from "../../icons";
import styles from '../Select.css';
import { selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var DropdownIndicator = function DropdownIndicator(props) {
  var _props$selectProps = props.selectProps,
      menuIsOpen = _props$selectProps.menuIsOpen,
      isMobile = _props$selectProps.isMobile,
      handleMenuToggle = _props$selectProps.handleMenuToggle,
      _props$selectProps$dr = _props$selectProps.dropdownIndicatorProps,
      dropdownIndicatorProps = _props$selectProps$dr === void 0 ? {} : _props$selectProps$dr,
      icon = _props$selectProps.icon,
      classes = _props$selectProps.classes,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled;
  var Component = isMobile ? 'div' : components.DropdownIndicator;
  var iconArrow = dropdownIndicatorProps.icon,
      onClick = dropdownIndicatorProps.onClick;

  var desktopProps = _objectSpread(_objectSpread({}, props), {}, {
    innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
      onMouseDown: onClick || innerProps.onMouseDown
    })
  });

  var handleTouchEnd = useCallback(function (e, touched) {
    if (touched) {
      if (onClick) {
        onClick(e);
      } else {
        handleMenuToggle(e);
      }
    }
  }, [handleMenuToggle, onClick]);
  var handleClick = useCallback(function (e) {
    if (onClick) {
      onClick(e);
    } else {
      handleMenuToggle(e);
    }
  }, [handleMenuToggle, onClick]);

  var _useTouchDetection = useTouchDetection({
    condition: isMobile && !isDisabled,
    onEnd: handleTouchEnd
  }),
      _useTouchDetection2 = _slicedToArray(_useTouchDetection, 2),
      touchEvents = _useTouchDetection2[0],
      isTouch = _useTouchDetection2[1];

  var mouseEvents = isTouch && isMobile && !isDisabled ? {
    onClick: handleClick
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: cx('indicator', classes.indicator)
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: cx('indicator-icon', classes.indicatorIcon)
  }, icon), /*#__PURE__*/React.createElement(Component, _extends({}, isMobile && !isDisabled ? touchEvents : desktopProps, mouseEvents, {
    className: cx('DropdownIndicator', {
      DropdownIndicator_open: menuIsOpen && !iconArrow,
      DropdownIndicator_disabled: isDisabled
    }, classes.dropdownIndicator)
  }), iconArrow || /*#__PURE__*/React.createElement(ChevronNormalDown, null)));
};
DropdownIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/boolean-prop-naming
  isDisabled: bool,
  selectProps: selectPropsPropTypes,
  innerProps: object
} : {};